
<template>
  <div id="app">
    <header class="header"
            @on-click-more="onClickMore"
            :class="{theme : $store.state.header}"
    >
      <img src="./assets/images/header_logo.png" class="left_logo" />
      <img src="./assets/images/menu_icon.png" class="right_icon" @click="drawerVisibility = !drawerVisibility"/>
    </header>

      <!-- drawer content -->
     <transition name="slide-fade">
      <div class="menu_wrape" v-show="drawerVisibility" @click="drawerVisibility = false">
          <div class="menu_content">
              <h5 class="title">更多</h5>
              <ul class="menu">
                <li :class="{active : $route.name == 'index'}">
                  <router-link :to="{ path: '/' }">首页</router-link>
                </li>

                <li :class="{active : $route.name == 'company_profile'}">
                  <router-link :to="{ path: '/company_profile' }" >公司概况</router-link>
                </li>

                <li :class="{active : $route.name == 'service_introduction'}">
                  <router-link :to="{ path: '/service_introduction' }" >服务介绍</router-link>
                </li>

                <li :class="{active : $route.name == 'core_strength'}">
                  <router-link :to="{ path: '/core_strength' }" >核心优势</router-link>
                </li>

                <li :class="{active : $route.meta.belong == 'news'}">
                  <router-link :to="{ path: '/news' }" >比逊新闻</router-link>
                </li>

                <li :class="{active : $route.name == 'join_us'}">
                  <!-- <router-link :to="{ path: '/join_us' }" >加入比逊</router-link> -->
                  <a href='https://app.mokahr.com/social-recruitment/medbanks/150528?locale=zh-CN#/'>加入比逊</a>
                </li>

                <li :class="{active : $route.name == 'contact_us'}">
                  <router-link :to="{ path: '/contact_us' }" >联系我们</router-link>
                </li>
              </ul>
          </div>
      </div>
      </transition>

      <router-view/>

     <div class="footer" :class="{fix : $store.state.footer}" v-show="$store.state.hidefooter">
        比逊（上海）医疗科技有限公司 <br/>
       <a class="beian" href="http://www.beian.gov.cn/portal/registerSystemInfo?recordcode=31010702005786" target="_blank">
         <img class="huizhang" src="./assets/images/huizhang.png" alt=""> 沪公网安备 31010702005786号

       </a> </br>
       <a class="beian" href="http://beian.miit.gov.cn">沪ICP备2021036162号</a>
     </div>
  </div>
</template>

<script>

  export default {
    created(){

    },
    methods: {
      onClickMore () {
        this.showMenu = true
      },

    },
    watch: {
      '$route' (to, from) {
         this.drawerVisibility = false;   //路由跳转、关闭侧边栏
       }
    },

    data () {
        return {
          drawerVisibility: false,
        }
    }
}
</script>

<style lang="less">
  html, body {
    height: 100%;
    width: 100%;
  }
  .huizhang {
    display: inline-block;
    width:15px;
    position: relative;
    top: -2px;
  }
  .beian {
    color: #fff;
  }
  .beian:hover  {
    color: #EF0000
  }

.menu_wrape{
     right:0;
     top:0;
     bottom: 0;
     background: rgba(0,0,0,0.5);
     z-index: 13;
     width:100%;
     height:100%;
     position: fixed;
    .menu_content{
        position: absolute;
        right: 0;
        min-height:100%;
        width: 260px;
        background: #fff;
        padding:30px 50px;
    }
     .title{
        color: #010613;
        font-size: 1.1rem;
        margin-bottom: 20px;
     }

     .menu{
        li{
           margin-bottom: 15px;
           color: #010613;
           font-size: px2rem(64);
           a{
               color: #010613;
           }

           &.active>a{
             color: #007ABE;
           }
        }


     }
}


.slide-fade-enter,
.slide-fade-leave-active {
    /*-webkit-transform: translate3d(100%, 0);*/
    /*transform: translateX(100%, 0);*/
    transform: translate3d(100%, 0, 0);
}

.slide-fade-enter-active,
.slide-fade-leave-active{
     /*transition: all 0.15s ease;*/
      transition:all .3s ease
}


.header{
      position: fixed;
      top:0;
      left: 0;
      right: 0;
      width: 100%;
      z-index: 10;
      background: rgba(255,255,255,0.1);
      padding: 10px 20px 13px 20px;
      .left_logo{
        width: 4.71875rem;
        height:1rem;
        display: inline-block;
      }

      .right_icon{
        width:1.125rem;
        height:1.125rem;
        float: right;
        top:5px;
        position: relative;
      }

      &.theme{
         background:#0086d1;
      }
}


.footer{
    font-size:14px;
    background-color: #1A1A1A;
    padding: 15px 10px;
    font-weight:300;
    color:#fff;
    text-align: center;
  &.fix{
     position: fixed;
     bottom: 0;
     width: 100%;
     left: 0;
     right:0;
     z-index: 11;
   }
}


</style>



// WEBPACK FOOTER //
// src/App.vue